export let API_ADDR = 'http://138.197.1.119:4040/api';
export let JSON_CONTENT_TYPE = 'application/json';
export let API_ERROR_MSG = 'Something wrong happened with the API. Please report this bug.';
export let API_TIMEOUT = 15000;



// WEBPACK FOOTER //
// ./src/providers/config.ts